import ReactDOM from 'react-dom';
import { useEffect, useState } from "react";
import app from "../components/app";

import {AppLink as Link, AppWrapper, AppBlocks} from "../components/helpers";
import Editor from "./editor";
import HtmlEditor from "./htmlEditor";
import Preview from "./preview";
import HeaderJson from "../components/header.json";
import FooterJson from "../components/footer.json";
import {submenuColors} from "../components/utility";
import {jsonToHtml} from "../components/htmlFromJson";

function updateIconSize(nextData) { 
    nextData = nextData.map(function(data){
        for (var k in data.elements) { 
            if (data.elements[k].viewType !== "grid") {
                if (data.elements[k]["properties"]) {
                    if(data.elements[k]["properties"]["iconSize"] !== undefined) {
                        data.elements[k]["properties"]["iconSize"] = data.elements[k]["properties"]["iconSize"].toString();
                    }
                    if(data.elements[k]["properties"]["iconSizeWeb"] !== undefined) {
                        data.elements[k]["properties"]["iconSizeWeb"] = data.elements[k]["properties"]["iconSizeWeb"].toString();
                    }
                }
            }
  
            if (data.elements[k]["items"]) {  
                data.elements[k]["items"].forEach(function(val) {
                    for (var key in val) {
                        if (key !== "viewType" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]) {
                                if(val[key]["properties"].iconSize !== undefined) {
                                    val[key]["properties"].iconSize  = val[key]["properties"].iconSize.toString();
                                }
                                if(val[key]["properties"].iconSizeWeb !== undefined) {
                                    val[key]["properties"].iconSizeWeb  = val[key]["properties"].iconSizeWeb.toString();
                                }
                            }
                        } 
                    } 
                }); 
            }  
        }
        return data;
    })
    return nextData;
} 

function isEmail(email) { 
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
}



export default function Users(props) {
    
    const [pages, setPages] = useState([]);
    const [data, setData] = useState(null);
    const [device, setPreviewDevice] = useState(localStorage.getItem("device"));
    
    useEffect(() => {
        window.setPreviewDevice = function(a){
            setPreviewDevice(a);
            localStorage.setItem("device", a);
        };

        app.loadConfig().then(function(){
            console.log("Ravi Kumar")
            reloadApp();
        });

    }, []);

    const reloadApp = async function() {
        if(props.id === "header" || props.id === "footer") {
            const response = await app.fetchPost({
                method: "list"
            }, true);
            const pages = response.results.filter(function(v){
                if(props.id === v.type) {
                    return true;
                }
                return false;
            });
            if(pages.length) {
                 let dynamicAIData = [];
                if(pages[0].data) {
                    dynamicAIData = JSON.parse(pages[0].data);
                }
                setData({
                    ...pages[0],
                    dynamicAIData
                });
            }
            else {
                if(props.id === "header") {
                    const headerData  = app.getDefaultHeader();
                    await app.fetchPost({...headerData,"method":"insert"});
                    setData({
                        ...headerData,
                        dynamicAIData:JSON.parse(headerData.data) 
                        });
                    
                }
                if(props.id === "footer") {
                    const footerData  = app.getDefaultFooter();
                    await app.fetchPost({...footerData,"method":"insert"});
                     setData({
                        ...footerData,
                        dynamicAIData:JSON.parse(footerData.data)
                        });
                    
                }
            }
        }
        
        else {
            const response = await app.fetchPost({
                method: "get",
                id: props.id,
            }, true);
            
            
            if(response.data) {
                if(response.data.type === "editor") {
                    let dynamicAIData = [];
                    if(response.data.data) {
                        dynamicAIData = JSON.parse(response.data.data);
                    }
                    console.log(dynamicAIData);
                    setData({
                        ...response.data,
                        dynamicAIData

                    // dynamicAIData: [data.headerData, ...dynamicAIData, data.footerData].filter(function(v){
                    //     if(v) {
                    //         return true;
                    //     } 
                    //     return false;
                    // })
                    });
                    const html = jsonToHtml({dynamicAIData:dynamicAIData});
                    //console.log(html);
                }
                if(response.data.type === "html") {
                    setData({
                        ...response.data
                    })
                }
            }
        }
    }

    const savePage = function(data) {
        data["data"] = JSON.stringify(data.dynamicAIData);
        data["html"] = jsonToHtml({dynamicAIData:data.dynamicAIData});
        app.fetchPost({
            ...data,
            "method":"update"
        });
    }

    const publishPage = function(data) {
        const html = jsonToHtml({dynamicAIData:data.dynamicAIData});
        data["data"] = JSON.stringify(data.dynamicAIData);
        data["html"] = html;
        data["publishedData"] = JSON.stringify(data.dynamicAIData);
        data["publishedHtml"] = html;
        app.htmlToImage(data).then(function(image){
             app.fetchBuilder({
                project:"files",
                domain:"karmtrust.org",
                method:"saveScreenshot",
                image:image,
                id:data.id
            }).then(function(response){
                app.fetchPost({
                    ...data,
                    "method":"update"
                });
            });
        })
       
    }

    const saveHTML = function(html) {
        data["html"] = html;
        app.fetchPost({
            ...data,
            "method":"update"
        });
    }

    const filterFooter = function(footerData) {
        if(footerData) {
            if(footerData.elements.copyright) {
                if(footerData.elements.copyright.viewType === "copyRight") {
                    footerData.elements.copyright.viewType = "text";
                }
            }
            if(footerData.elements.logo) {
                if(footerData.elements.logo.properties.showLogo === undefined) {
                    footerData.elements.logo.properties.showLogo = true;
                    footerData.elements.logo.properties.showLogoWeb = true;
                }
            }
            if(!footerData.settings) {
                footerData.settings = {
                    "hideFooter": false
                }
            }
            ["logo", "footerSocialInfo", "footerNavigation"].forEach(function(v){
                if(footerData.elements[v]) {
                    if(footerData.elements[v].properties.textAlignment === undefined) {
                        footerData.elements[v].properties.textAlignment = "center";
                    }
                }
            });
        }
        return footerData;
    }

    const filterHeader = function(headerData) {
        if(headerData) {
            if(headerData.elements.navigation.properties["customMenu"] === undefined) {
                headerData.elements.navigation.properties["customMenu"] = false;
                submenuColors.forEach(function(v){
                    headerData.elements.navigation.properties[v.key] = v.value;
                });
            }
            if(headerData.elements.logo) {
                if(headerData.elements.logo.properties.showLogo === undefined) {
                    headerData.elements.logo.properties.showLogo = true;
                    headerData.elements.logo.properties.showLogoWeb = true;
                }
            }
            if(headerData.elements.headerIcons) {
                if(headerData.elements.headerIcons.icons.cart.showWeb === undefined) {
                    ["cart", "notification", "location"].forEach(function(v){
                        headerData.elements.headerIcons.icons[v].showWeb = true;
                    })
                }
            }
        }
        return headerData;
    }

    if(data) {
        if(data.type === "html") {
            return <>
                <link rel="stylesheet" type="text/css" href="/css/ui.css"/> 
                <HtmlEditor data={data} callback={saveHTML} publishPage={saveHTML} />
            </>
        }
        return <>
            <link rel="stylesheet" type="text/css" href="/css/ui.css"/> 
            <Editor data={data} id={props.page} type="pages" callback={savePage} publishPage={publishPage} />
        </>
    }
    return <div></div>
}